<template src="./titlePage.html"></template>

<script>
export default {
    name: 'title-page',
    props: ['currentSelectedTab'],
    data() {
        return {
        }
    },
    computed: {
       titlePageData() {
            return this.$store.state.SessionsModule.Session;
       },
    },
    methods: {
        getRowsForSection(data) {
            let rows = [];
            
            for (let i = 0; i < data.length; i += 2) {
                let row = [];
    
                row.push(data[i]);
                
                if (i + 1 < data.length) {
                    row.push(data[i + 1]);
                } else {
                    row.push({}); 
                }
                
                rows.push(row);
            }
                
            return rows;
        },
        // checkBottomLeftItemIndex(fields, index) {
        //     if (this.isLastOddField(fields)) {
        //         if (index === fields.length - 1) {
        //             return true;
        //         }
        //     }

        //     if (!this.isLastOddField(fields) && index === fields.length - 2) {
        //         return true;
        //     }

        //     return false;
        // },
        // checkBottomRightItemIndex(fields, index) {
        //     if (this.isLastOddField(fields)) {
        //         return false;
        //     }

        //     if (index === fields.length - 1) {
        //         return true;
        //     }

        //     return false;
        // },
        // isLastOddField(fields) {
        //     if (fields.length % 2 === 1) {
        //         return true;
        //     }

        //     return false;
        // },
    }
}
</script>